import axios from 'axios'
import { ERROR_CODE, RES_STATUS, responseMessage } from 'constants/common'
import { COOKIE_AUTH_TOKEN } from 'constants/common'
import { ENV } from 'constants/env'
import { IResponse } from 'interfaces/services'
import Cookies from 'js-cookie'

export const authBaseAxios = axios.create({
  baseURL: `${ENV.baseApi}/${ENV.versionApi}`
})

authBaseAxios.interceptors.request.use(
  function (config) {
    const authToken = Cookies.get(COOKIE_AUTH_TOKEN)
    return {
      ...config,
      headers: {
        // 'Content-Type': 'application/json',
        'accept-language': 'vi',
        Authorization: `Bearer ${authToken}`
      }
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)

authBaseAxios.interceptors.response.use(
  function (response) {
    try {
      return {
        _status: RES_STATUS.SUCCESS,
        _statusRes: response.status,
        _message: response.data?.error_message || response.data?.debug_message,
        _errorCode: response.data?.error_code,
        _successfully: response.data?.error_code === ERROR_CODE.SUCCESS,
        data: response.data?.data
      } as IResponse<any>
    } catch (error: any) {
      return {
        _status: RES_STATUS.FAIL,
        _statusRes: error?.status,
        _successfully: false,
        _errorCode: error.error_code,
        _message: responseMessage[RES_STATUS.FAIL],
        data: null
      }
    }
  },
  function (error) {
    try {
      const { response } = error
      if (!response) {
        // throw new Error(messageNetwork)
      }
      if (response) {
        return {
          _status: RES_STATUS.FAIL,
          _statusRes: response.status,
          _message:
            response.data?.error_message || response.data?.debug_message,
          _successfully: false,
          _errorCode: response?.data?.error_code,
          data: response.data
        }
      }
    } catch (err: any) {
      return {
        _status: RES_STATUS.FAIL,
        _statusRes: err.status,
        _successfully: false,
        _errorCode: err.error_code,
        _message: responseMessage[RES_STATUS.FAIL],
        data: null
      }
    }
  }
)
